<script setup lang="ts">
import Paginator from 'primevue/paginator';
import { inject } from 'vue';

import { PaginatorEmits, PaginatorProps } from './Paginator.vue.d';
import Icon from '../icon/Icon.vue';

defineProps<PaginatorProps>();
defineEmits<PaginatorEmits>();

const rows = defineModel<number>('rows');

const Preset = inject<Record<string, any>>('preset', {}).datatable;
</script>

<template>
  <Paginator
    v-model:rows="rows"
    v-bind="Preset.paginator({ context: { totalRecords } })"
    :template
    :total-records="totalRecords"
    @page="$emit('page', $event)"
  >
    <template #firstpagelinkicon>
      <Icon icon="round-keyboard-double-arrow-left" />
    </template>

    <template #lastpagelinkicon>
      <Icon icon="round-keyboard-double-arrow-right" />
    </template>

    <template #prevpagelinkicon>
      <Icon icon="round-keyboard-arrow-left" />
    </template>

    <template #nextpagelinkicon>
      <Icon icon="round-keyboard-arrow-right" />
    </template>
  </Paginator>
</template>
